import styled from "styled-components"

export const Row = styled.div`
  display: flex;
`

export const RowMiddle = styled.div`
  min-width: 0;
  width: 100%;
  display: flex;
  align-items: center;
`

export const RowStart = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 120px;
`

export const RowEnd = styled.div`
  width: 150px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
